import { render, staticRenderFns } from "./VIconTooltip.vue?vue&type=template&id=3237711a&scoped=true&functional=true"
import script from "./VIconTooltip.vue?vue&type=script&lang=js"
export * from "./VIconTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3237711a",
  null
  
)

export default component.exports